export default __webpack_public_path__ + "static/media/pdl-logo.47425c3e.png";